import logo from "../../../assets/logo.svg";
import MenuItems from "./MenuItems";
import "./index.css";

const Sidebar = () => {
  return (
    <div className="container">
      <div className="sidebar">
        <img src={logo} className="logo" />
        <MenuItems />
      </div>
    </div>
  );
};

export default Sidebar;
